import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import "./i18n";

window.renderRevOpsOrderPage = (state) => {
  if (process.env.REACT_APP_STAGE !== "prod") {
    console.log("THE STATE", state);
  }
  return new Promise((resolve, reject) => {
    ReactDOM.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18next}>
          <App
            containerId={state.containerId}
            type={state.type}
            devmode={state.devmode}
            resolve={resolve}
            reject={reject}
            modal={state.modal}
            tsId={state.tsId}
            email={state.email}
            name={state.shopUrl || state.name}
            firstName={state.firstName}
            lastName={state.lastName}
            lang={state.lang}
            authTokenStream={state.authTokenStream}
          />
        </I18nextProvider>
      </React.StrictMode>,
      document.getElementById(state.containerId)
    );
  });
};

window.unmountRevOpsOrderPage = (state) => {
  ReactDOM.unmountComponentAtNode(document.querySelector('control-centre-app').shadowRoot.querySelector("#"+state.containerId));
};

serviceWorker.unregister();
